import React from "react";
import { Stack, TextField, ThemeProvider } from "@mui/material";
import { rootColors } from "../../utilities/Colors/Colors";
import customTheme from "../../utilities/customTheme/customTheme";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        height: "324px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px 0px",
      }}
    >
      <Stack
        sx={{
          width: { xs: "90%", lg: "80%" },
          flexDirection: { xs: "column-reverse", lg: "row" },
          justifyContent: "space-between",
        }}
      >
        <Stack
          sx={{
            mt: { xs: 5, lg: 0 },
          }}
        >
          <Stack sx={{ fontSize: { xs: "20px", md: "28px" }, fontWeight: 500 }}>
            AI Assistant
          </Stack>
          <Stack sx={{ fontSize: { xs: "15px", md: "18px" } }}>
            Subscribe to our newletter for weekly updates and promotions.
          </Stack>
          <Stack sx={{ flexDirection: "row", gap: "20px", mt: "22px" }}>
            <ThemeProvider theme={customTheme}>
              <TextField sx={{ width: "100%" }} size="small" />
              <Stack
                component={"button"}
                sx={{
                  bgcolor: rootColors?.primary,
                  border: "none",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  justifyContent: "center",
                  color: rootColors?.text,
                  p: "0 24px",
                  borderRadius: "4px",
                  fontSize: { xs: "16px", md: "16px" },
                  fontWeight: 500,
                }}
              >
                Sign up
              </Stack>
            </ThemeProvider>
          </Stack>
        </Stack>
        <Stack
          sx={{
            width: "311px",
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
            mt: { xs: 5, lg: 0 },
          }}
        >
          {footerLinks?.map((item, index) => (
            <Stack key={index} gap={"10px"}>
              <Stack sx={{ fontSize: "16px", fontWeight: 700 }}>
                {item?.title}
              </Stack>
              {item?.links?.map((link, index) => (
                <Link
                  key={index}
                  style={{ textDecoration: "none", color: rootColors?.text }}
                >
                  <Stack sx={{ fontSize: "16px", fontWeight: 400 }}>
                    {link?.title}
                  </Stack>
                </Link>
              ))}
            </Stack>
          ))}
        </Stack>
      </Stack>
    </footer>
  );
};

export default Footer;

const footerLinks = [
  {
    title: "Products",
    links: [
      { title: "Features", path: "#" },
      { title: "Testimonials", path: "#" },
      { title: "Highlights", path: "#" },
      { title: "Pricing", path: "#" },
      { title: "FAQs", path: "#" },
    ],
  },
  {
    title: "Company",
    links: [
      { title: "About us", path: "#" },
      { title: "Careers", path: "#" },
      { title: "Press", path: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { title: "Terms", path: "#" },
      { title: "Privacy", path: "#" },
      { title: "Contact", path: "#" },
    ],
  },
];
